import FaqAccordion from "@/Components/UI/FaqAccordion";
import { PaymentFormData } from "@/Components/UI/Onboarding/Client/PaymentForm/PaymentForm";
import { buildFaqItems } from "@/Components/UI/PaymentFaq/faqItems";
import { AnalyticsContext } from "@/Contexts/AnalyticsContext";
import { useContext } from "react";

export default function ProactivePaymentFaq({
    paymentFormData,
    forceShow = false,
}: {
    paymentFormData: PaymentFormData;
    forceShow?: boolean;
}) {
    const { trackEvent } = useContext(AnalyticsContext);

    const isShown =
        forceShow ||
        paymentFormData.faqsOnProactivePaymentPageVariant === "treatment";

    if (!isShown) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2 pb-6">
            <h2 className="mt-4 px-6 text-xs font-semibold uppercase tracking-wider text-brand-gray">
                A few things to know
            </h2>
            <FaqAccordion
                items={buildFaqItems(paymentFormData)}
                panelIdPrefix="proactive-faq-panel"
                onItemOpened={(slug) =>
                    trackEvent("faq_expanded", {
                        page: route().current() ?? "unknown",
                        faq: slug,
                    })
                }
            />
        </div>
    );
}
